import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material';

import {FeedbackService} from '../../../../services/feedback.service';
import {LogService} from '../../../../services/log.service';


@Component({
	selector: 'help-faq',
	templateUrl: './help-faq.component.html',
	styleUrls: ['./help-faq.component.scss']
})
export class HelpFaqComponent implements OnInit {
	constructor(
		private router: Router,

		private log: LogService
	) {}


	help = false;

	@Output()
	navToFaq = new EventEmitter();


	ngOnInit() {
	}


	goToFaq() {
		this.navToFaq.next();

		console.log('goToFaq clicked!!');
		this.help = false;
		// this.router.navigate(['profile'], { queryParams: { faq: 1 } });
		this.log.showFaq = true;
		this.router.navigate(['common/profile']);
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/help-faq/help-faq.component.ts